import { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import GuidedFlow from "../../primerUso/GuidedFlow";
import ImportarConfigLocal from "../../importarConfig/ImportarConfigLocal";
import { datosImportados } from "../../importarConfig/configImportada";
import useCobrosHabilitados from "../../hooks/useCobrosHabilitados";
import { TAB_DEL_PASO, datosInicialesSalon } from "./salonPayload";
import { pasosSalon } from "./salonPasos";
import { guardarOpcional, progresoInicial, publicarSalon } from "./salonServicios";

const MODULO = {
  nombre: "Turnos Beauty",
  publicado: "Tu salón ya puede recibir turnos.",
  resumenReq: "Salón, ubicación, horarios, servicios, equipo y cómo se reserva",
};

/**
 * First run of Turnos Beauty (the negocio has no salon yet): required steps create the salon, its
 * services and its professionals; optional steps complete the salon through /salon/update.
 * `onTerminar(ctx, tab)` hands control back to the module; `tab` is a module tab id (or null).
 * `onSalonCreado(id)` (multi-sede only) fires once the salon exists, before its services are added.
 */
const TurnosGuidedFlow = ({ states, onTerminar, onCancelar, onSalonCreado }) => {
  const negocio = useSelector((s) => s.auth)?.negocio?.nombre || "";
  // Until it is known whether the account can charge, deposits stay locked.
  const { cargando, puedeCobrar } = useCobrosHabilitados();
  const senasBloqueadas = cargando || !puedeCobrar;
  const soloGratis = !cargando && !puedeCobrar;
  // Survives retries of "Abrir turnos": nothing created before a failure is created twice.
  const progreso = useRef(progresoInicial());

  const pasos = useMemo(() => pasosSalon({ states, senasBloqueadas }), [states, senasBloqueadas]);
  const datosIniciales = useMemo(() => datosInicialesSalon(negocio), [negocio]);

  return (
    <GuidedFlow
      modulo={MODULO}
      pasosReq={pasos.req}
      pasosOpc={pasos.opc}
      datosIniciales={datosIniciales}
      accionInicial={({ data, set }) => (
        <ImportarConfigLocal tipo="beauty" importado={data.importado} onImport={(config) => set(datosImportados(config))} />
      )}
      onPublicar={(d) => publicarSalon(d, progreso.current, { soloGratis, alCrearSalon: onSalonCreado })}
      onGuardarOpc={(paso, d, ctx) => guardarOpcional(paso, d, ctx)}
      onIrSeccion={(paso, ctx) => onTerminar(ctx, TAB_DEL_PASO[paso.id] || null)}
      onIrModulo={(ctx) => onTerminar(ctx, null)}
      onCancelar={() => onCancelar(progreso.current.salon)}
    />
  );
};

export default TurnosGuidedFlow;
